module.exports = __webpack_public_path__ + "static/media/Icon awesome-home.b9cdfee5.svg";